// src/components/sections/HeroSection.js

import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="bg-primary text-white py-10 px-6 md:px-12 text-center">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          The Better Turns Movement
        </h1>
        <p className="text-lg md:text-xl mb-8 leading-relaxed">
          A grassroots revolution reclaiming local economies, empowering small
          retailers, and restoring community prosperity.
        </p>
        <Link
          to="/join"
          className="inline-block bg-sunshine-yellow text-deep-navy font-semibold px-6 py-3 rounded hover:bg-warm-orange transition-colors"
        >
          Join the Movement
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
